enum AppRoutes {
  Root = '/',
  Login = '/login',
  UserManagement = '/users',
  UserWithId = '/users/:id',
  UserInvitations = '/users/invitations',
  CompaniesManagement = '/companies',
  ProfilePage = '/profile',
  Introduction = '/introduction',
  Dashboard = '/dashboard',
  Conversations = '/conversations',
  ConversationsWithId = '/conversations/:id',
  CourseManagement = '/courses',
  GroupManagement = '/groups',
  GlobalAssetsLibrary = '/library',
  CallManagement = '/calls',
  EvaluationProtocolManager = '/evaluation-protocols',
  EvaluationProtocolWithId = '/evaluation-protocols/:id',
  Scene = '/scene',
  SceneWithId = '/scene/:id',
  ScenarioPlayer = '/scenario/:id',
  ScenarioPlayerNotes = '/scenario/:id/notes',
  ScenarioPlayerCompleted = '/scenario/:id/completed',
  MyCourses = '/my-courses',
  UserGuides = '/user-guides',
  MyDashboard = '/my-dashboard',
  Translator = '/translator',
  Scenarios = '/scenarios',
  Statistics = '/statistics',
  UsageStatistics = '/usage-statistics',
  RecentJobs = '/recent-jobs',
  CompanyDetail = '/companies/:companyId',
  PersonasManager = '/personas',
  PersonaWithId = '/personas/:id',
  ExercisesManager = '/exercises',
  ExerciseWithId = '/exercises/:id'
}

export enum GroupManagementRoutes {
  Root = '/groups',
  Group = '/groups/:groupId'
}

export enum SceneRoutes {
  Root = '/scene',
  Scene = '/scene/:sceneId'
}

export enum CourseManagementRoutes {
  Root = '/courses',
  Course = '/courses/:courseId',
  Schedule = '/courses/:courseId/schedule',
  ScheduledCourse = '/courses/:courseId/schedule/:scheduledCourseId',
  ScheduledCourseResults = '/courses/:courseId/schedule/:scheduledCourseId/results',
  ScheduledCourseUserGroups = '/courses/:courseId/schedule/:scheduledCourseId/user-groups',
  ScheduledCourseNotifications = '/courses/:courseId/schedule/:scheduledCourseId/notifications'
}

export enum MyCoursesRoutes {
  Root = '/my-courses',
  ScheduledCourse = '/my-courses/:scheduledCourseId'
}

export default AppRoutes;
